import React from "react";
import "./AccessDenied.css";

const Noaccess = () => {
  return (
    <div className="no">
      <div className="error-container">
        <div className="error-illustration"> </div>
        <div className="error-code">404</div>
        <h1 className="error-title">Page Not Found</h1>
        <p className="error-message">
          {/* Sorry, you don't have permission to access this page. */}
          {/* <br /> */}
          If you believe this is an error, please contact the administrator.
        </p>
      </div>
    </div>
  );
};

export default Noaccess;
